import React, { Component } from "react";
import firebase from "../Firebase";
import { ReactComponent as Sunny } from '../img/weatherIcons/wi-day-sunny.svg'
import { ReactComponent as PtCloud } from '../img/weatherIcons/wi-day-cloudy.svg'
import { ReactComponent as Thunderstorms } from '../img/weatherIcons/wi-day-lightning.svg'
import { ReactComponent as ScatteredStorms } from '../img/weatherIcons/wi-day-rain-mix.svg'
import { ReactComponent as WindRain } from '../img/weatherIcons/wi-day-cloudy-windy.svg'
import { ReactComponent as WindRainHeavy } from '../img/weatherIcons/wi-day-rain-wind.svg'
import { ReactComponent as Showers } from '../img/weatherIcons/wi-showers.svg'
import { ReactComponent as Smoke } from '../img/weatherIcons/wi-smoke.svg'
import { ReactComponent as Kayak } from '../img/svg/kayak.svg'
import { ReactComponent as Raft } from "../img/svg/raft.svg";
import { ReactComponent as Hiker } from "../img/svg/hiker.svg";
import { ReactComponent as Angler } from "../img/svg/angler.svg";
import { ReactComponent as Binoculars } from "../img/svg/binoculars.svg";
import { ReactComponent as Tube } from "../img/svg/tube.svg";
import { ReactComponent as Bird } from "../img/svg/bird.svg";
import { ReactComponent as SUP } from "../img/svg/sup.svg";
import { ReactComponent as Alert } from "../img/svg/alert.svg";
import DatePicker from "react-datepicker";
import Intro from '../layout/partails/Intro'
import Message from '../components/Message'
import "react-datepicker/dist/react-datepicker.css";



class Create extends Component {
	constructor() {
        super();
        this.ref = firebase.firestore().collection("test");
		this.state = {
            activity: "",
            algae:"",
            date: new Date().toLocaleString(),
            dead:"no",
            fieldNotes: "",
            habitat: "",
            lat:"",
            lon:"",
			observation: "",
			river: "",
            section: "",
            temperature:"",
            startDate: new Date(),
			submittedBy: "",
			waterTemperature: "",
            weather:"",
            other: "none",
            latitude:"",
            longitude:"",
            enabled: false,
     
      
            // ui state
            otherSelected:"",

      
        };
        this.getLocation = this.componentDidMount.bind(this)
         this.getLocation = this.getLocation.bind(this)
         this.getCoordinates = this.getCoordinates.bind(this)
       
	}

	/// lets build the webpage here and scroll to top
	componentDidMount() {
        window.scrollTo(0, 0);
        const state = this.state;
        state.stringDate = 
        this.setState(state);
    }
    
    // location based functions
    getLocation() {
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.getCoordinates)
            window.location.reload(false);
        } else {
            alert('Unable to access your coordinates st this time. Please enable access location to use')
        }
    }

    getCoordinates(position) {
       this.setState({
         lat:   position.coords.latitude,
         lon:   position.coords.longitude
        })
        alert('your current location has been updated')
        localStorage.setItem('lat',  position.coords.latitude)
        localStorage.setItem('lon',  position.coords.longitude)
    }

	// custom functions
// my custom functions
setRiver = value => () => {
    const state = this.state;
    state.river = value;
    state.section="";
    state.other="none"
    state.otherSelected="false"
    localStorage.setItem('river', value)
    this.setState(state);
    };
setCreek = value => () => {
    const state = this.state;
    state.river = value;
    state.section="";
    localStorage.setItem('river', value)
    this.setState(state);
    };

setOther = value => () => {
    const state = this.state;
    state.river = "";
    state.otherSelected="true"
    localStorage.setItem('other', value)
    this.setState(state);
    };

setDead = value => () => {
    const state = this.state;
    state.dead = value;
    state.deadObservation="";
    localStorage.setItem('dead', value)
    this.setState(state);
    };
    
setSection = value => () => {
    const state = this.state;
    state.section = value;
    localStorage.setItem('section', value)

    this.setState(state);
    };
    setHabitat = value => () => {
    const state = this.state;
    localStorage.setItem('habitat', value)
    state.habitat = value;
    this.setState(state);
    };
    setAlgae = value => () => {
    const state = this.state;
    state.algae = value;
    this.setState(state);
    localStorage.setItem('algae', value)

    };
    setWeather = value => () => {
    const state = this.state;
    state.weather = value;
    this.setState(state);
    localStorage.setItem('weather', value)

    };
    setActivity = value => () => {
    const state = this.state;
    state.activity = value;
    this.setState(state);
    localStorage.setItem('activity', value)

    };
    closeMessage = value => () => {
    const state = this.state;
    state.messageToggle = value;
    this.setState(state);
    };

    handleChange = date => {
    this.setState({
    startDate: date
    });
    };
    
    onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    localStorage.setItem('temperature', e.target.value)
    };
    onChange1 = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    localStorage.setItem('waterTemperature', e.target.value)
    };
    onChangeNotes = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    localStorage.setItem('fieldNotes', e.target.value)
    };
    onChangeLatitude = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    localStorage.setItem('lat', e.target.value)
    };
    onChangeLongitude= (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    localStorage.setItem('lon', e.target.value)
    };

	onSubmit = (e) => {
		e.preventDefault();

    
    const state = this.state;
    state.formSubmitted = "true";
    this.setState(state);
    
		const {
			activity,
            algae,
            date,
            dead,
            fieldNotes,
            habitat,
            lat,
            lon,
			observation,
			river,
			section,
            startDate,
            temperature,
			waterTemperature,
            weather,
		} = this.state;

		this.ref
			.add({
                activity,
                algae,
                date,
                dead,
                fieldNotes,
                habitat,
                lat,
                lon,
                observation,
                river,
                section,
                startDate,
                temperature,
                waterTemperature,
                weather,
			})
			.then((docRef) => {
				this.setState({
					activity: "",
                    algae:"",
                    dead:"",
                    date:"",
                    habitat: "",
                    lat:"",
                    lon:"",
					observation: "",
					river: "",
					section:"",
                    startDate:"",
                    temperature:"",
                    weather:"",
					waterTemperature: "",
				});
				this.props.history.push("/success");
			})
			.catch((error) => {
				console.error("Error adding document: ", error);
			});
	};

	render() {
      
   
        const { 
            activity,
            algae, 
            dead,  
            fieldNotes, 
            habitat,
            observation,
            river, 
            section,
            temperature,
            startDate,
            weather,
            waterTemperature,
        } = this.state;
        const lat =  localStorage.getItem('latitude');
        const lon =  localStorage.getItem('longitude');

		return (
        <>
			<div> 
                <Message />
                <Intro />
			</div>
            <div className="card">
        <div className="card-content">
        <h2>Date </h2>
            <div>
                <h2>Select Date</h2>
                <DatePicker 
                className="input" 
                showTimeSelect dateFormat="Pp"
                selected={startDate} 
                onChange={this.handleChange} />
            </div>
        </div>
    </div>
 
    <div className="card">
        <div className="card-content">
            <h2>Rivers</h2>
            {this.state.river ? <p>You Selected: {river}</p> : null}
            {!river ? <p>No River Selected: </p> : null}
            <div className="button-row-5">
                <div><button className="button" onClick={this.setRiver("Colorado River")}> Colorado River </button></div>
                <div><button className="button" onClick={this.setRiver("Crystal River")}> Crystal River </button></div>
                <div><button className="button" onClick={this.setRiver("Fryingpan River")}> Fryingpan River </button></div>
                <div><button className="button" onClick={this.setRiver("Roaring Fork River")}> Roaring Fork River</button></div>
                <div><button className="button" onClick={this.setOther("true")}> Other  </button></div>
            </div>
        </div>
    </div>

    {this.state.river === "Roaring Fork River" && this.state.other==="none" ?
    <div className="card">
        <h2> Select Section on the {river} </h2>
        {section ? <p>You Selected: {section}</p> : null}
        {!section ? <p>Select Section</p> : null}
        <div className="button-row-4">
            <div><button className="button" onClick={this.setSection("Above Aspen")}> Above Aspen </button>
        </div>
            <div><button className="button" onClick={this.setSection("Aspen - Carbondale")}> Aspen - Carbondale
                </button>
            </div>
            <div><button className="button" onClick={this.setSection("Carbondale - Mouth")}> Carbondale - Mouth
                </button>
            </div>
        </div>
    </div>
    : null }


    {this.state.river === "Fryingpan River"  && this.state.other==="none"  ?
    <div className="card">
        <h2> Select Section on the {river} </h2>
        {section ? <p>You Selected: {section}</p> : null}
        {!section ? <p>Select Section</p> : null}
        <div className="button-row-4">
            <div>
                <button className="button" onClick={this.setSection("Above Ruedi")}> Above Ruedi </button>
            </div>
            <div>
                <button className="button" onClick={this.setSection("Below Ruedi")}> Below Ruedi </button></div>
            </div>
    </div>

    : null } 
    {this.state.river === "Crystal River"  && this.state.other==="none"  ?
    <div className="card">
        <h2> Select Section on the {river} </h2>
        {section ? <p>You Selected: {section}</p> : null}
        {!section ? <p>Select Section</p> : null}
        <div className="button-row-4">
            <div><button className="button" onClick={this.setSection("Above Marble")}> Above Marble </button></div>
            <div><button className="button" onClick={this.setSection("Marble - Redstone")}> Marble - Redstone </button>
            </div>
            <div><button className="button" onClick={this.setSection("Redstone - Carbondale")}> Redstone - Carbondale
                </button></div>
            
        </div>
    </div>
    : null }

{this.state.river === "Colorado River" ?
<>
<div className="card">
    <h2>Select Section of the Colorado River</h2>
    
    <div className="button-row-3">
    <div><button className="button" onClick={this.setCreek("Colorado River above confluence with Roaring Fork River")}> Above Roaring Fork confluence</button></div>
    <div><button className="button" onClick={this.setCreek("Colorado River below confluence with Roaring Fork River")}> Below Confluence with Roaring Fork River</button></div>
        
    </div>
</div>
</> : null}

{this.state.otherSelected==="true" ? 
<>

<div className="card">
            <div className="card-content">
                <h2>Creeks - Tributaries of the Roaring Fork River and other Rivers</h2>
        {this.state.river ? <p>You Selected: {river}</p> : null}
            {!river ? <p>No Creeks Selected: </p> : null}
            </div>
            <div className="button-row-4">
                <div><button className="button" onClick={this.setRiver("Avalanche Creek")}> Avalanche Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Brush Creek")}> Brush Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Cattle Creek")}> Cattle Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Capitol Creek")}> Capitol Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Castle Creek")}> Castle Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Coal Creek")}> Coal Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Coulter Creek")}> Coulter Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Deeds Creek")}> Deeds Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Grizzly Creek")}> GrizzlyCreek </button></div>
                <div><button className="button" onClick={this.setRiver("Fourmile Creek")}> Fourmile Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Hunter Creek")}> Hunter Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Last Chance Creek")}>Last Chance Creek  </button></div>
                <div><button className="button" onClick={this.setRiver("Lincoln Creek")}> Lincoln Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Little Elk Creek")}> Little Elk Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Lyle Creek")}> Lyle Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Maroon Creek")}> Maroon Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Mormon Creek")}> Mormon Creek </button></div>
                <div><button className="button" onClick={this.setRiver("No Name Creek")}> No Name Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Snowmass Creek")}> Snowmass Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Thompson Creek")}> Thompson Creek</button></div>
                <div><button className="button" onClick={this.setRiver("Threemile Creek")}> Threemile Creek </button></div>
                <div><button className="button" onClick={this.setRiver("Woody Creek")}> Woody Creek </button></div>
               
                
</div>
        </div>
           
            
</>

: null }


{this.state.river === "Brush Creek" ?
<>
<div className="card">
    <h2>Select Section of Brush Creek</h2>

    <div className="button-row-4">
    <div><button className="button" onClick={this.setCreek("Brush Creek Below Snowmass rodeo Lot")}> Below Snowmass Rodeo Lot</button></div>
    <div><button className="button" onClick={this.setCreek("Brush Creek Above Snowmass rodeo Lot")}> Above Snowmass rodeo Lot</button></div>
        
    </div>
</div>
</> : null}
{this.state.river === "Castle Creek" ?
<>
<div className="card">
    <h2>Select Section of Castle Creek</h2>
    <div className="button-row-3">
    <div><button className="button" onClick={this.setCreek("Castle Creek Above Ashcroft")}> Above Ashcroft</button></div>
    <div><button className="button" onClick={this.setCreek("Brush Creek Below Ashcroft")}> Below Ashcroft</button></div>
        
    </div>
</div>
</> : null}
{this.state.river === "Cattle Creek" ?
<>
<div className="card">
    <h2>Select Section of Cattle Creek</h2>
    <div className="button-row-3">
    <div><button className="button" onClick={this.setCreek("Cattle Creek Above County Road 100")}> Above County Road 100</button></div>
    <div><button className="button" onClick={this.setCreek("Cattle Creek Below County Road 100")}> Below County Road 100</button></div>

        
    </div>
</div>
</> : null}
{this.state.river === "Fourmile Creek" ?
<>
<div className="card">
    <h2>Select Section of Fourmile Creek</h2>
    <div className="button-row-4">
    <div><button className="button" onClick={this.setCreek("Fourmile Creek Above Dry Park")}>Fourmile Creek Above Dry Park</button></div>
    <div><button className="button" onClick={this.setCreek("Fourmile CReek Below Dry Park Road")}>Below Dry Park Road</button></div>
        
    </div>
</div>
</> : null}


<div className="card">
                <div className="card-content">
                    {lat && lon ? "Thank you for enabling location services on your device" : "Please enable location services on your device"}
                    <p>GPS coordinates help us with accuracy and are valued data asset.</p>
                    <div><p>Your Location: {lat} {lon}</p><br /></div>
                    <div>Note a dash appear in front of your Longitude like: -107.1087666</div>
                    <div className="card-content col-2">
                    <div className="center"><p>-lat</p></div>
                        <div>
                            <input type="text" name="lat"
                                    onChange={this.onChangeLatitude}
                                    placeholder={lat}
                                    value={lat}/></div>
                            <div className="center"><p>-lon</p>
                        </div>
                        <div>
                            <input type="text"
                                    onChange={this.onChangeLongitude} 
                                    name="lon"
                                    placeholder={lon}
                                    value={lon}/>
                        </div>
                    </div>
                    <div className="caption center"></div>
                </div>
                <button onClick={this.getLocation} className="button">Fund / Update my location</button>
            </div>


<div className="card">
        <div className="card-content">
            <h2>Select Weather Conditions</h2>
            {weather ? <p>{weather}</p> : null}
            {!weather ? <p>none</p> : null}
        </div>
        <div className="card-content button-row-4">
            <div className="square-button">
                <Sunny className="icon" onClick={this.setWeather("Sunny")} />
            </div>
            <div className="square-button">
                <PtCloud className="icon" onClick={this.setWeather("Party cloudy")} />
            </div>
            <div className="square-button">
                <WindRain className="icon" onClick={this.setWeather("High Clouds with breezes")} />
            </div>
            <div className="square-button">
                <Thunderstorms className="icon" onClick={this.setWeather("Thunderstorms")} />
            </div>
            <div className="square-button">
                <ScatteredStorms className="icon" onClick={this.setWeather("Scattered showers")} />
            </div>
            <div className="square-button">
                <WindRainHeavy className="icon" onClick={this.setWeather("Wind and rain")} />
            </div>
            <div className="square-button">
                <Showers className="icon" onClick={this.setWeather("Steady rain")} />
            </div>
            <div className="square-button" onClick={this.setWeather("Smoke")}>
                <Smoke className="icon" />
            </div>
        </div>
    </div>
    <div className="card">
        <div className="card-content">
            <h2>Select Air Temperature</h2>
            <div>
                {temperature ? <p>{temperature}&deg;</p> : null}
                {!temperature ? <p>none</p> : null}
                <input type='range' name='temperature' value={temperature} min='32' onChange={this.onChange} />
            </div>
        </div>
    </div>
    <div className="card">
        <div className="card-content">
            <h2>Select Water Temperature</h2>
            <div>
                {waterTemperature ? <p>{waterTemperature}&deg;</p> : null}
                {!waterTemperature ? <p>none</p> : null}
                <input type='range' name='waterTemperature' value={waterTemperature} min='32'
                    onChange={this.onChange1} />
            </div>
        </div>
    </div>
    <div className="card">
        <h2>Select Habitat Type</h2>
        {habitat ? <p>{habitat}</p> : null}
        {!habitat ? <p>none</p> : null}
        <div className="button-row-3">
            <div><button className="button" onClick={this.setHabitat("Riffle")}> Shallow - Riffle </button></div>
            <div><button className="button" onClick={this.setHabitat("Thalweg")}> Thalweg - preferred </button></div>
            <div><button className="button" onClick={this.setHabitat("Pool")}> Pool - Slow </button></div>
        </div>
    </div>

    <div className="card">
        <h2>Stream Bottom Conditions</h2>
        {algae ? <p>{algae}</p> : null}
        {!algae ? <p>Describe the algae or slime present.</p> : null}
        <div className="button-row-3">
            <div><button className="button" onClick={this.setAlgae("No algae observed")}> No Algae Present
                </button></div>
            <div><button className="button" onClick={this.setAlgae("Algae in the thalweg")}> Algae in the
                    Thalweg</button></div>
            <div><button className="button" onClick={this.setAlgae("Algae in the shallows")}>Algae in the
                    Shallows</button></div>
            <div><button className="button" onClick={this.setAlgae("Drifting algae")}>Drifting Algae</button></div>
            <div><button className="button" onClick={this.setAlgae("Abundant algae")}>Abundant Algae</button></div>
            <div><button className="button" onClick={this.setAlgae("Shoreline slime")}>Shoreline Slime</button></div>
        </div>
    </div>

    {dead ==="yes" ?
    <div className="card message">
        <p>Please keep your observation limited to dead fish, birds, or other animals encountered in the river and along the shoreline.</p>
        <input type="text" onChange={this.onChange} name="observation" placeholder="Describe what you see..." />
    </div>
    : null}
    <div className="card button-row-2">
        <div>
            <h2>Dead Fish, Birds or Animals</h2>
            <p>Did you see any mortalities on the river today?</p>
        </div>
        <div>
            {dead ==="yes" ? <button className="button" onClick={this.setDead("no")}>No</button>:null}
            {dead ==="no" ? <button className="button" onClick={this.setDead("yes")}>Click if Yes</button>:null}
        </div>
        <div />
    </div>


<div className="card">
    <div> 
        <h2>Field Observations (optional)</h2>
    </div>
    <div>    
        <textarea

            onChange={this.onChangeNotes}
            className='textarea'
            name='fieldNotes'
            id='fieldNotes'
            value={fieldNotes}
            rows='4'
            placeholder='Field Observations' />
    </div>
</div>


    <div className="card">
        <h2>What is Your Activity</h2>
            <p>{activity}</p>
<div className="button-row-4">
    <div className="square-button" onClick={this.setActivity("Fishing")}><Angler className="icon" /></div>
    <div className="square-button" onClick={this.setActivity("Hiking")} ><Hiker className="icon" /></div>
    <div className="square-button" onClick={this.setActivity("Rafting")} ><Raft className="icon" /></div>
    <div className="square-button" onClick={this.setActivity("Kayaking")} ><Kayak className="icon" /></div>
    <div className="caption">Fishing</div>
    <div className="caption">Hiking</div>
    <div className="caption">Rafting</div>
    <div className="caption">Kayaking</div>
    <div className="square-button" onClick={this.setActivity("Paddle Boarding")} ><SUP className="icon" /></div>
    <div className="square-button" onClick={this.setActivity("Tubing")} ><Tube className="icon" /></div>
    <div className="square-button" onClick={this.setActivity("Watching Wildlife")} ><Binoculars className="icon" /></div>
    <div className="square-button" onClick={this.setActivity("Collecting Data")} ><Bird className="icon" /></div>
    <div className="caption">Paddle Boarding</div>
    <div className="caption">Tubing</div>
    <div className="caption">Wildlife watching</div>
    <div className="caption">Collecting Data</div>
        </div>
    </div>

<div className="card">
    <h2>You have entered the following observations:</h2>
    {river ? <p><b>River: </b>{river}</p> : <span className="alert-small">
        <h3>Missing: River</h3>
    </span>}
    {section ? <p><b>Section: </b>{section}</p> : null}
    {river === "Roaring Fork River" && !section ? <span className="alert-small">
        <h3>Missing: River Section </h3>
    </span>: null }
    {river ==="Crystal River" && !section ? <span className="alert-small">
        <h3>Missing: River Section </h3>
    </span>: null}
    {river ==="Fryingpan River" && !section ? <span className="alert-small">
        <h3>Missing: River Section </h3>
    </span> : null}
    {weather ? <p><b>Weather: </b>{weather}</p> : <span className="alert-small">
        <h3>Missing: Weather Observation</h3>
    </span>}
    {temperature ? <p><b>Air Temperature: </b>{temperature}</p> : <span className="alert-small">
        <h3>Missing: Air Temperature</h3>
    </span>}
    {waterTemperature ? <p><b>Water Temperature: </b>{waterTemperature}</p> : <span className="alert-small">
        <h3>Missing: Water Temperature</h3>
    </span>}
    {habitat ? <p><b>Habitat Type: </b>{habitat}</p> : <span className="alert-small">
        <h3>Missing: Habitat Type Sampled</h3>
    </span>}
    {algae ? <p><b>Stream Bottom Observation: </b>{algae}</p> : <span className="alert-small">
        <h3>Missing: Stream Bottom Observation</h3>
    </span>}
    {activity ? <p><b>Activity: </b>{activity}</p> : <span className="alert-small">
        <h3>Missing: Activity</h3>
    </span>}
    {observation ? <p>Mortality Observation: {observation}</p>: null}
    {river && weather && temperature && waterTemperature && habitat && activity ?
    <span>
        <h2> Is this information correct?</h2>
        {!this.state.formSubmitted ?  <button className="button" type="submit" onClick={this.onSubmit}>Submit</button> : null}
       
    </span>
    :
    <div className="message">
        <div className="col-2">
            <div>
                <Alert className="alert-icon" />
            </div>
            <div>
                <p>You cannot submit this form until all required observations have been entered.</p>
            </div>
        </div>
    </div>
    }
</div>
        </>
		);
	}
}

export default Create;
